import NoSleep from "nosleep.js";
import { useEffect, useMemo, useRef, useState } from "react";
import { translations } from '../i18n/config';
import { getLanguage } from "../utils/anyUtils";

export const useTranslation = () => {
    const [localization, setLocalization] = useState(translations['en']);
    let languageRef = useRef<string>('en');

    useEffect(() => {
        const language = getLanguage()
        localStorage.setItem("lang", language!)
                //@ts-ignore
        const translation = translations[language!] ? translations[language!] : translations['en'];
        setLocalization(translation)
        languageRef.current = language
    }, [])

    const getTranslation = (context: string) => {
        //@ts-ignore
        return localization[context]
    }
    const changeLanguage = (newLanguage: string) => {
        localStorage.setItem("lang", newLanguage)
        //@ts-ignore
        const translation = translations[newLanguage!] ? translations[newLanguage!] : translations['en'];
        setLocalization(translation)
        languageRef.current= newLanguage
        localStorage.setItem("asw-user-settings", JSON.stringify({lang: newLanguage, states: []}))
    }

    return {
        getTranslation,
        changeLanguage,
        languageRef
    }
};